export default function NotificationIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 24C13.6569 24 15 22.6569 15 21H9C9 22.6569 10.3431 24 12 24Z"
        fill="#AFBACA"
      />
      <path
        d="M13.4927 1.64855C13.4975 1.59968 13.5 1.55013 13.5 1.5C13.5 0.671573 12.8284 0 12 0C11.1716 0 10.5 0.671573 10.5 1.5C10.5 1.55013 10.5025 1.59969 10.5073 1.64856C7.0803 2.34067 4.50003 5.36901 4.50003 9C4.50003 10.6464 3.75 18 1.5 19.5H22.5C20.25 18 19.5 10.6464 19.5 9C19.5 5.36899 16.9197 2.34063 13.4927 1.64855Z"
        fill="#AFBACA"
      />
    </svg>
  );
}
